// src/services/alertService.js
// Global alert service that can be used from anywhere (including non-React code)

class AlertService {
  constructor() {
    this.listeners = [];
  }

  // Subscribe to alert events
  subscribe(listener) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }

  // Show alert from anywhere in the app
  show(message, type = 'info', title = '') {
    console.log('[AlertService] Showing alert:', { message, type, title, listeners: this.listeners.length });
    if (this.listeners.length === 0) {
      console.warn('[AlertService] No listeners registered! Make sure GlobalAlertDialog is mounted.');
    }
    this.listeners.forEach(listener => {
      listener({ message, type, title, isOpen: true });
    });
  }

  // Convenience methods
  success(message, title = '') {
    this.show(message, 'success', title);
  }

  warning(message, title = '') {
    this.show(message, 'warning', title);
  }

  error(message, title = '') {
    this.show(message, 'error', title);
  }

  info(message, title = '') {
    this.show(message, 'info', title);
  }
}

const alertService = new AlertService();
export default alertService;
